// extracted by mini-css-extract-plugin
module.exports = {"layout":"ks","whiteBackground":"kt","content":"ku","searchContent":"kv"};